/**
 * Removes trailing slashes from a URL or path
 * @param url - The URL or path to normalize
 * @returns The normalized URL/path without trailing slashes
 *
 * @example
 * normalizeTrailingSlash('/api/') // Returns: '/api'
 * normalizeTrailingSlash('/api//') // Returns: '/api'
 * normalizeTrailingSlash('https://example.com/') // Returns: 'https://example.com'
 */
export function normalizeTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}
